export type ArticleElement = {
  type: "text" | "header" | "subheader" | "image";
  content: string;
};

export interface Article {
  id: string;
  title: string;
  elements: ArticleElement[];
  createdAt: number;
  updatedAt: number;
}

const STORAGE_KEY = "mdl_articles";

const HARDCODED_ARTICLES: Article[] = [
  {
    id: "hardcoded_sumba_2025",
    title: "2016-01 Trip",
    elements: [
      { type: "header", content: "Besuch in Sumba" },
      { type: "subheader", content: "Dezember 2025 bis Januar 2026" },
      {
        type: "text",
        content:
          "Ende Dezember 2025 bis Anfang Januar 2026 waren wir auf Sumba, der drittärmsten Insel Indonesiens. Wir sind sehr dankbar, dass wir die Möglichkeit hatten, den Menschen vor Ort zu begegnen, Einblicke in ihren Alltag zu gewinnen und ihre Lebenssituation kennenzulernen. Mit großer Freude konnten wir Lebensmittel mit den Bewohnern in Gaura und Weijana teilen und gemeinsam mit ihnen essen. Diese Zeit hat uns tief bewegt und unser Herz für Dankbarkeit, Nächstenliebe und Teilen neu erfüllt.",
      },
      { type: "image", content: "/mdl_sumba_25_26.png" },
    ],
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
];

export const articleService = {
  // Create
  createArticle: (title: string, elements: ArticleElement[]): Article => {
    const article: Article = {
      id: `article_${Date.now()}`,
      title,
      elements,
      createdAt: Date.now(),
      updatedAt: Date.now(),
    };
    const stored = localStorage.getItem(STORAGE_KEY);
    const localStorageArticles = stored ? JSON.parse(stored) : [];
    localStorageArticles.push(article);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(localStorageArticles));
    return article;
  },

  // Read
  getAllArticles: (): Article[] => {
    const stored = localStorage.getItem(STORAGE_KEY);
    const localStorageArticles = stored ? JSON.parse(stored) : [];
    return [...HARDCODED_ARTICLES, ...localStorageArticles];
  },

  getArticleById: (id: string): Article | undefined => {
    const articles = articleService.getAllArticles();
    return articles.find((a) => a.id === id);
  },

  // Update
  updateArticle: (
    id: string,
    title: string,
    elements: ArticleElement[],
  ): Article | null => {
    const stored = localStorage.getItem(STORAGE_KEY);
    const localStorageArticles = stored ? JSON.parse(stored) : [];
    const index = localStorageArticles.findIndex((a: Article) => a.id === id);
    if (index === -1) return null;

    localStorageArticles[index] = {
      ...localStorageArticles[index],
      title,
      elements,
      updatedAt: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(localStorageArticles));
    return localStorageArticles[index];
  },

  // Delete
  deleteArticle: (id: string): boolean => {
    const stored = localStorage.getItem(STORAGE_KEY);
    const localStorageArticles = stored ? JSON.parse(stored) : [];
    const filtered = localStorageArticles.filter((a: Article) => a.id !== id);
    if (filtered.length === localStorageArticles.length) return false;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    return true;
  },

  // Initialize with hardcoded data (no longer needed, kept for backward compatibility)
  initializeHardcodedData: () => {
    // Hardcoded articles are now always available from HARDCODED_ARTICLES constant
    // No localStorage initialization needed
  },
};
